import gql from 'graphql-tag';

const DATA_EXPLORER_CHERRE_CITY_STATE = gql`
    query DataExplorerCherreCityState($params: DataExplorerCherreCityStateParams) {
        dataExplorerCherreCityState(params: $params)
    }
`;

export default DATA_EXPLORER_CHERRE_CITY_STATE;
